
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'
import FormTextInput from './FormTextInput'
import FormSwitchInput from './FormSwitchInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormEmployeeAccount = ({
  colSize,
  inputLabel,
  className,
  employeeAccounts,
  handleAddEmployeeAccounts,
  errors,
  handleChangeAccount,
  handleRemoveEmployeeAccount,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel className='fs-6 fs-md-3'>
          {inputLabel}
        </CFormLabel>
        {
          !disabled && (
            <CButton
              onClick={() => handleAddEmployeeAccounts()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {employeeAccounts?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {employeeAccounts?.length > 0 && (
        employeeAccounts?.map((inputField, index) => {
          return (
            <CAccordion>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Account {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Account Number
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='account_number'
                        name='account_number'
                        colSize='6'
                        placeholder='Enter account number...'
                        value={inputField.account_number}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeAccount(e, index)}
                        feedbackInvalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].account_number : null}
                        invalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].account_number : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Account Name
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='account_name'
                        name='account_name'
                        colSize='6'
                        placeholder='Enter account name...'
                        value={inputField.account_name}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeAccount(e, index)}
                        feedbackInvalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].account_name : null}
                        invalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].account_name : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Bank Name
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='bank_name'
                        name='bank_name'
                        colSize='6'
                        placeholder='Enter bank name...'
                        value={inputField.bank_name}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeAccount(e, index)}
                        feedbackInvalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].bank_name : null}
                        invalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].bank_name : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Bank Branch
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='bank_branch'
                        name='bank_branch'
                        colSize='6'
                        placeholder='Enter bank branch...'
                        value={inputField.bank_branch}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeAccount(e, index)}
                        feedbackInvalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].bank_branch : null}
                        invalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].bank_branch : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-5'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Main Account?
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormSwitchInput 
                        id='is_main_account'
                        name='is_main_account'
                        colSize='6'
                        className='mb-3'
                        disabled={disabled}
                        handleSwitch={(e) => handleChangeAccount(e, index)}
                        value={inputField.is_main_account}
                        invalid={!disabled && errors.employee_accounts?.length > 0 ? errors?.employee_accounts[index].is_main_account : null}
                      />
                    </CCol>
                  </CRow>
                  {
                    employeeAccounts?.length > 1 && !disabled && (
                      <CButton
                        style={styleButtonVars2}
                        onClick={() => {handleRemoveEmployeeAccount(inputField, index)}}
                      >
                        Delete Account
                      </CButton>
                    )
                  }
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          )
        })
      )}
    </CCol>
  )
}

export default FormEmployeeAccount
